<template>
  <div class="pie-chart-cont">
    <t-loading attach=".pie-chart-cont" v-if="loading"></t-loading>

    <div class="left">
      <div class="row" v-for="item in list" v-bind:key="item.targetName">
        <div style="text-align: center">{{ item.targetName }}</div>
        <div style="flex: 1" v-loading="item.loading">
          <base-circular-graph
            :options="item.options"
            :date-keys="item.dateKeys"
            :legend-data="item.legendData"
            :show-legend="false"
            :show-compare-date="item.showCompareDate"
            style="height: 100%"
          ></base-circular-graph>
        </div>
      </div>
    </div>
    <div class="right">
      <!--<div style="display: flex">-->
      <!--  <t-select-->
      <!--    v-model="topN"-->
      <!--    @change="handleChangeTopN"-->
      <!--    placeholder="请选择"-->
      <!--    class=""-->
      <!--    style="width: 130px; margin-right: 10px"-->
      <!--  >-->
      <!--    <t-option v-for="item in topNOptions" :key="item.value" :label="item.label" :value="item.value"></t-option>-->
      <!--  </t-select>-->
      <!--  <t-input-->
      <!--    placeholder="请输入关键词过滤"-->
      <!--    v-model="legendSearchWord"-->
      <!--    clearable-->
      <!--    @change="handleLegendSearchWordChange"-->
      <!--  ></t-input>-->
      <!--</div>-->

      <div class="legend-cont">
        <div
          class="legend-item"
          v-for="item in myLegendData"
          :key="item.name"
          @click="handleClick(item)"
          :class="{ grey: !item.show }"
        >
          <div class="icon" :style="{ backgroundColor: item.show ? item.color : 'rgb(234, 234, 234)' }"></div>
          <div :title="item.desc" class="name">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { uniqWith } from 'lodash';
import noData from '@/components/common/no-data-card.vue';
import BaseCircularGraph from '@/components/analysis/chart/base-circular-graph.vue';

export default {
  components: {
    noData,
    BaseCircularGraph,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    showCompareDate: {
      type: Boolean,
      default: false,
    },
    legendData: {
      type: Array,
      default: () => [],
    },
    legendDataWd: {
      type: Array,
      default: () => [],
    },
    dateKeys: {
      type: Object,
    },
    options: {
      type: Object,
    },
    searchWord: {
      type: String,
      required: true,
    },
    topNumber: {
      type: Number,
      default: 10,
    },
  },

  data() {
    return {
      topNOptions: [
        { label: '前10项', value: 10 },
        { label: '前20项', value: 20 },
        { label: '前30项', value: 30 },
        { label: '前40项', value: 40 },
        { label: '前50项', value: 50 },
      ],
      // topN: 10,
      // legendSearchWord: '',
      myLegendData: [],
    };
  },
  watch: {
    legendData: {
      deep: true,
      handler() {
        this.setMyLegendData();
      },
    },
    topNumber() {
      this.setMyLegendData();
    },
    searchWord() {
      this.setMyLegendData();
    },
  },
  computed: {
    list() {
      const { showCompareDate, options, dateKeys, myLegendData } = this;
      const { seriesMap, seriesMapCompare } = options;
      // 一个指标一行 ，对比同一行
      const targetList = [...seriesMap.reduce((base, item) => base.add(item.target_name), new Set())];
      return targetList.map(targetName => ({
        targetName,
        showCompareDate,
        dateKeys,
        legendData: myLegendData,
        options: {
          seriesMap: seriesMap.filter(item => item.target_name === targetName),
          seriesMapCompare: seriesMapCompare.filter(item => item.target_name === targetName),
        },
      }));
    },
  },
  mounted() {
    this.setMyLegendData();
  },
  methods: {
    setMyLegendData() {
      let newList = this.legendDataWd.filter(item => item.name.includes(this.searchWord)).slice(0, this.topNumber);
      newList = uniqWith(newList, (a, b) => a.name === b.name); // 去重
      this.myLegendData = JSON.parse(JSON.stringify(newList));
    },
    handleChangeTopN() {
      this.setMyLegendData();
    },
    handleLegendSearchWordChange() {
      this.setMyLegendData();
    },
    handleClick(item) {
      item.show = !item.show;
    },
  },
};
</script>
<style lang="less" scoped>
.pie-chart-cont {
  min-height: 400px;
  display: flex;

  .left {
    flex: 1;
    display: flex;
    flex-direction: column;

    .row {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .right {
    width: 270px;
    padding: 0 0 0 10px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: column;
  }

  .legend-cont {
    flex: 1;
    overflow: auto;

    .legend-item {
      display: flex;
      align-items: center;
      line-height: 38px;
      cursor: pointer;
      &:hover {
      }

      &.grey {
        color: #c0ccda;
        .icon {
          background-color: rgb(234, 234, 234);
        }
      }

      .icon {
        width: 20px;
        height: 4px;
        //border: 1px solid red;
        //background-color: rgb(234, 234, 234);
        margin-right: 8px;
      }

      .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
